import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SidebarItemContainer } from './styles';
import { SideBarItemProps } from './types';

export const SideBarItem: React.FC<SideBarItemProps> = ({
  testId,
  action,
  label,
  onClose,
  selectNode,
  path,
  history,
  opened,
  isBarOpen,
}) => {
  const active = history?.location?.pathname.startsWith(path);

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault();
      if (selectNode) selectNode();
      if (onClose) onClose();

      if (action) {
        action();
      } else if (path && history) {
        history.push(path);
      }
    },
    [action, onClose, selectNode, history, path],
  );

  useEffect(() => {
    if (active && !opened) {
      selectNode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, isBarOpen]);

  return (
    <SidebarItemContainer active={active} data-testid={testId} href={path} onClick={onClick}>
      {label}
    </SidebarItemContainer>
  );
};

export default SideBarItem;
